module.exports = __webpack_public_path__ + "static/media/Architecture_29.732331fc.jpg";